module.exports = __webpack_public_path__ + "img/product_90.0d71c5a.webp";